'use client';

import { token } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Badge } from '../../../components/badge';

export const ApiDocumentationRequiredBadge = () => {
  const t = useTranslations(
    'designSystem.documentsReports.applicationDocumentation',
  );

  return (
    <Badge
      variant="outline"
      size="sm"
      bg={token('colors.bg.severity.critical')}
      borderColor={token('colors.border.severity.critical')}
    >
      {t('required')}
    </Badge>
  );
};
